import { useContext } from "react";
import { AuthContext } from "../context/authContext";

const Sesion = () => {
    const { logOut } = useContext(AuthContext);

    return (
        <ul className="sesion nav" >
            <li className="nav-link" onClick={() => logOut()}>
                <span to="/admin/login" className="nav-link fs-5">
                    <strong> <i className="bi bi-person"></i></strong>
                </span>
            </li>
        </ul>
    )
}

export default Sesion;
